import { featuredProducts } from '../../../mocks/products';

const WA_BASE = 'https://wa.me/573228000501?text=Hola%2C%20me%20interesa%20el%20producto%20';

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={`${i < count ? 'ri-star-fill' : 'ri-star-line'} text-sm text-amber-400`} />
      ))}
    </div>
  );
}

export default function FeaturedProducts() {
  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4 tracking-tight">
            Promos Del Momento
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Descubre nuestras mejores ofertas en ropa y fragancias.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          {featuredProducts.map((product) => (
            <div key={product.id} className="group bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-500">
              {/* Image */}
              <div className="relative overflow-hidden">
                <div className="absolute top-4 left-4 z-10 bg-gradient-to-r from-amber-400 to-amber-500 text-white px-4 py-1.5 rounded-full text-xs font-medium flex items-center gap-1.5 whitespace-nowrap">
                  <i className="ri-star-fill text-sm" />
                  Destacado
                </div>
                {product.discount && (
                  <div className="absolute top-4 right-4 z-10 bg-red-500 text-white px-3 py-1.5 rounded-full text-xs font-bold whitespace-nowrap">
                    {product.discount}
                  </div>
                )}
                <div className="aspect-[4/5] w-full overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xl md:text-2xl font-light text-gray-900">
                    {product.name}
                  </h3>
                  <StarRating count={product.rating} />
                </div>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  {product.description}
                </p>

                {/* Review quote */}
                {product.review && (
                  <div className="bg-amber-50/50 border border-amber-100 rounded-xl p-4 mb-5">
                    <div className="flex items-start gap-2">
                      <i className="ri-double-quotes-l text-amber-400 text-lg flex-shrink-0 mt-0.5" />
                      <p className="text-sm text-gray-700 italic leading-relaxed">
                        {product.review}
                      </p>
                    </div>
                    <p className="text-xs text-gray-500 mt-2">
                      {product.reviews} reseñas verificadas
                    </p>
                  </div>
                )}

                <div className="flex items-center justify-between mb-5">
                  <div className="flex items-center gap-3">
                    {product.originalPrice && (
                      <span className="text-lg text-gray-400 line-through font-light">
                        {product.originalPrice}
                      </span>
                    )}
                    <span className="text-3xl font-bold text-red-600">{product.price}</span>
                  </div>
                  {product.originalPrice && (
                    <span className="text-xs text-red-500 font-semibold bg-red-50 border border-red-100 px-2.5 py-1 rounded-full whitespace-nowrap">
                      ¡Oferta especial!
                    </span>
                  )}
                </div>

                <a
                  href={`${WA_BASE}${encodeURIComponent(product.name)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-xl font-medium transition-all duration-300 flex items-center justify-center gap-2 group/btn whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl" />
                  Consultar por WhatsApp
                </a>
                <p className="text-xs text-center text-gray-500 mt-3 leading-relaxed">
                  Pregunta por disponibilidad en WhatsApp
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-sm text-gray-600 flex items-center justify-center gap-2">
            <i className="ri-checkbox-circle-fill text-amber-500" />
            Productos seleccionados especialmente para ti
          </p>
        </div>
      </div>
    </section>
  );
}
